var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77998 5.28C6.92067 5.42052 6.99981 5.61116 6.99998 5.81V6.19C6.99768 6.38842 6.91887 6.57828 6.77998 6.72001L1.63998 11.85C1.5461 11.9447 1.4183 11.9979 1.28498 11.9979C1.15166 11.9979 1.02386 11.9447 0.929982 11.85L0.219982 11.14C0.125918 11.0478 0.0729102 10.9217 0.0729102 10.79C0.0729102 10.6583 0.125918 10.5322 0.219982 10.44L4.66998 6L0.219982 1.56C0.125325 1.46612 0.0720825 1.33832 0.0720825 1.205C0.0720825 1.07169 0.125325 0.943888 0.219982 0.850005L0.929982 0.150005C1.02386 0.0553486 1.15166 0.00210571 1.28498 0.00210571C1.4183 0.00210571 1.5461 0.0553486 1.63998 0.150005L6.77998 5.28Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.902a19c5.svg";
export { ForwardRef as ReactComponent };